var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { EntityBuilder } from '@decahedron/entity';
import env from 'config/env';
import { Form } from 'packages/form/entities/legacy/Form';
import { Form as V2Form } from 'packages/form/entities/Form';
import axios from 'axios';
var FormRepository = /** @class */ (function (_super) {
    __extends(FormRepository, _super);
    function FormRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = V2Form;
        _this.url = 'v2/forms';
        _this.baseUrl = env.JOBILLA_API_ROOT;
        return _this;
    }
    /**
     * Search forms by name and query
     * The name param here means title of a form most likely.
     */
    FormRepository.prototype.searchGlobal = function (search, paging, version, sorting, name) {
        return __awaiter(this, void 0, Promise, function () {
            var q;
            return __generator(this, function (_a) {
                q = __assign(__assign({}, paging), { query: search, name: name, version: version });
                if (sorting) {
                    q.order = {
                        field: sorting.field,
                        direction: sorting.direction,
                    };
                }
                return [2 /*return*/, this.get(this.url + "/search", null, q)
                        .then(function (response) { return ({
                        items: response.data.data.map(function (formData) {
                            return (formData.version === 1 ?
                                EntityBuilder.buildOne(Form, formData) :
                                EntityBuilder.buildOne(V2Form, formData));
                        }),
                        pagination: response.data.pagination,
                    }); })];
            });
        });
    };
    FormRepository.prototype.getAllForJob = function (jobId, paging) {
        if (paging === void 0) { paging = {
            page: 1,
            per_page: 50,
        }; }
        return __awaiter(this, void 0, Promise, function () {
            var query, lastPage, forms, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = __assign(__assign({}, paging), { filters: { job_id: jobId } });
                        lastPage = 1;
                        forms = [];
                        _a.label = 1;
                    case 1:
                        if (!(query.page <= lastPage)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.get(this.url, null, query)
                                .then(function (response) { return ({
                                items: EntityBuilder.buildMany(V2Form, response.data.data),
                                pagination: response.data.pagination,
                            }); })];
                    case 2:
                        response = _a.sent();
                        forms = forms.concat(response.items);
                        lastPage = response.pagination.last_page;
                        query.page += 1;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, forms];
                }
            });
        });
    };
    FormRepository.prototype.createFromTemplate = function (template, jobId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.post(this.url + "/generate-from-template", {
                        template_uuid: template.uuid,
                        job_id: jobId,
                    }).then(function (response) {
                        if (response.version === 1) {
                            return EntityBuilder.buildOne(Form, response);
                        }
                        return EntityBuilder.buildOne(V2Form, response);
                    })];
            });
        });
    };
    FormRepository.prototype.createForm = function (form) {
        return __awaiter(this, void 0, Promise, function () {
            var entity;
            var _this = this;
            return __generator(this, function (_a) {
                entity = this.entity;
                this.entity = null;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return [2 /*return*/, this.post(this.url, form)
                        .then(function (response) {
                        return (response.data.version === 1 ?
                            EntityBuilder.buildOne(Form, response.data) :
                            EntityBuilder.buildOne(V2Form, response.data));
                    })
                        .finally(function () { return _this.entity = entity; })];
            });
        });
    };
    FormRepository.prototype.updateForm = function (form) {
        return this.put(this.url + "/" + form.uuid, form)
            .then(function (formData) { return (formData.version === 1 ?
            EntityBuilder.buildOne(Form, formData) :
            EntityBuilder.buildOne(V2Form, formData)); });
    };
    FormRepository.prototype.find = function (id) {
        return this.get(this.url + "/" + id)
            .then(function (response) { return response.data.data; })
            .then(function (formData) { return (formData.version === 1 ?
            EntityBuilder.buildOne(Form, formData) :
            EntityBuilder.buildOne(V2Form, formData)); });
    };
    FormRepository.prototype.sendAdditionalForm = function (payload) {
        var _this = this;
        return this.axios.post(env.JOBILLA_API_ROOT + "v2/mail/form-request", payload).then(function (response) { return _this.responseTransformer(response); });
    };
    FormRepository.prototype.export = function (formId) {
        return axios.get(env.JOBILLA_API_ROOT + "v2/form-responses/" + formId + "/export")
            .then(function (res) { return res.data; });
    };
    FormRepository.prototype.exportAllResponsesForRecruitment = function (jobId, format) {
        if (format === void 0) { format = 'csv'; }
        return axios.get(env.JOBILLA_API_ROOT + "v2/form-responses/recruitment/" + jobId + "/export?format=" + format, { responseType: 'blob' })
            .then(function (res) { return res.data; });
    };
    FormRepository.prototype.revalidateCachedForm = function (formUuid) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.axios.post(env.APPS.FORM_VIEWER.URL + "api/revalidate", {}, {
                        params: { secret: env.FORM_REVALIDATE_SECRET, tag: formUuid },
                    }).then(function (response) { return _this.responseTransformer(response); })];
            });
        });
    };
    return FormRepository;
}(AbstractRepository));
export { FormRepository };
